import Color from 'color'
import {DropDownList} from '@syncfusion/ej2-dropdowns'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import store from "../store";

export const AVAILABLE = 1
export const NOT_AVAILABLE = 2
export const SCHEDULING_NOTE = 3

export class SchedulerHelper {
  constructor(vm) {
    this.vm = vm
  }

  onPopupOpen(args) {
    const method = args.type[0].toLowerCase() + args.type.slice(1) + 'Popup'
    if (typeof this[method] === 'function') {
      this[method](args)
    }
  }

  quickInfoPopup(args) {
    args.element.querySelector('.e-subject').style.maxHeight = 'none'
    if ([AVAILABLE, NOT_AVAILABLE, SCHEDULING_NOTE].includes(args.data.EventType)) {
      this.headerFontTextBlack(args)
    }
    this.handleEmptySubject(args)
  }

  // Mobile has a ViewEventInfo event type, not QuickInfo
  viewEventInfoPopup(args) {
    this.quickInfoPopup(args)
  }

  headerFontTextBlack(args) {
    args.element.querySelector('.e-subject').style.color = 'black'
    args.element.querySelectorAll('.e-icons').forEach(icon => {
      icon.style.color = 'black'
    })
  }

  editEventInfoPopup(args) {
    if (args.data.EventType !== SCHEDULING_NOTE) {
      return
    }
    this.headerFontTextBlack(args)
  }

  recurrenceAlertPopup(args) {
    if (args.element.innerText.includes('delete')) {
      return
    }
    const button = args.element.querySelectorAll('button')[1]
    button.style.display = 'none'
  }

  editorPopup(args) {
    args.element.querySelector('.e-description-row').style.display = 'none'
    // Absolutely ludicrous, but the only way to get the editor to show the time picker
    if (this.vm.scheduler.currentView === 'Month' && ! args.target.classList.contains("e-appointment")) {
      args.element.querySelectorAll('.e-time-icon')[1].classList.remove('e-icon-disable')
      args.element.querySelectorAll('.e-time-icon')[0].classList.remove('e-icon-disable')
      args.element.querySelector('.e-time-zone-container').classList.remove('e-disable')
      args.element.querySelector('.e-start').ej2_instances[0].format = "M/d/yy h:mm a"
      args.element.querySelector('.e-end').ej2_instances[0].format = "M/d/yy h:mm a"
      args.element.querySelector('.e-start').ej2_instances[0].value.setHours(9, 0, 0)
      args.element.querySelector('.e-end').ej2_instances[0].value.setHours(9, 30, 0)
      args.element.querySelector('.e-start').ej2_instances[0].dataBind()
      args.element.querySelector('.e-all-day.e-checkbox').ej2_instances[0].checked = false
    }

    this.createEventTypeDropdown(args)

    // No yearly events
    const recurrenceEditor = document.querySelector('.e-recurrenceeditor').ej2_instances[0]
    recurrenceEditor.frequencies = [
      'none', 'daily', 'weekly', 'monthly'
    ]
    recurrenceEditor.refresh()

    // hide the mobile repeat options on desktop
    if (store.getters.platform === 'desktop') {
      document.querySelectorAll('.e-repeat-container > *').forEach(node => node.style.display = 'none')
    }

    // "Until" is the only end type we can use
    recurrenceEditor.endType.getItems().forEach(node => (node.innerText !== 'Until') && node.remove())
    let dataSource = recurrenceEditor.endType.dataSource
    dataSource = dataSource.filter(item => item.text === 'Until')
    recurrenceEditor.endType.setSelection(recurrenceEditor.endType.getItems()[0])
  }

  createEventTypeDropdown(args) {
    // Ugh...
    const customField = args.element.querySelector('#event-type-row .e-field')
    if (customField) {
      customField.ej2_instances[0].value = args.data.EventType || NOT_AVAILABLE
      return
    }

    // Ugh...
    let row = document.createElement('div')
    row.id ='event-type-row'
    row.classList.add('event-type-row')
    let formElement = args.element.querySelector('.e-schedule-form')
    formElement.firstChild.insertBefore(row, args.element.querySelector('.e-title-location-row'))
    let container = document.createElement('div')
    container.classList.add('custom-field-container')
    let inputEle = document.createElement('input')
    inputEle.classList.add('e-field')
    inputEle.setAttribute('name', 'EventType')
    container.appendChild(inputEle)
    row.appendChild(container)

    let dropDownList = new DropDownList({
      dataSource: [
        {text: 'Not Available', value: NOT_AVAILABLE},
        {text: 'Scheduling Note', value: SCHEDULING_NOTE},
      ],
      fields: {text: 'text', value: 'value'},
      value: args.data.EventType || NOT_AVAILABLE,
      floatLabelType: 'Always', placeholder: 'Event Type'
    })

    dropDownList.appendTo(inputEle)
  }

  onEventRendered(args, inspectorColor) {
    this.setBackgroundColor(args, args.element, inspectorColor)
    this.handleEmptySubject(args)
  }

  // Don't allow resizing of recurring events since it creates a recurrence exception which cs2 doesn't support
  resizeStart(args) {
    if (args.data.RecurrenceRule) {
      args.cancel = true
    }
  }

  dragStart(args) {
    if (window.ontouchstart || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
      args.cancel = true
      return
    }
    if (args.data.RecurrenceRule) {
      args.cancel = true
    }
  }

  dragStop(args) {
    const draggingToAnotherInspector = args.event.element.dataset.groupIndex !== args.event.target.dataset.groupIndex

    if (draggingToAnotherInspector) {
      args.cancel = true
    }
  }

  setBackgroundColor(args, element, inspectorColor) {
    const eventTypes = {
      [AVAILABLE]: {
        class: 'event-available',
        backgroundColor: Color('#C8E1EBFF'),
        color: Color('#000000FF')
      },
      [NOT_AVAILABLE]: {
        class: 'event-not-available',
        backgroundColor: Color('#f5BE6BFF'),
        color: Color('#000000FF')
      },
      [SCHEDULING_NOTE]: {
        class: 'event-scheduling-note,',
        backgroundColor: Color('#FFFF00FF'),
        color: Color('#000000FF')
      },
    }

    let cssClasses = [eventTypes[args.data.EventType]?.class || 'event-inspection']

    if ( args.data.EndTime < new Date()) { // TODO: this assumes the timezone of the event is the same as the browser
      cssClasses.push('event-past')
    }

    element.classList.add(...cssClasses)

    element.style.backgroundColor = eventTypes[args.data.EventType]?.backgroundColor?.string() || '#0000FF'

    if (eventTypes[args.data.EventType]?.color) {
      element.style.color = eventTypes[args.data.EventType].color.string()
    }
  }

  getCalendarEventPayload(calendarEvent) {
    const parsedRule = this.parseRecurrenceRule(calendarEvent.RecurrenceRule)

    const startDateTime = format(calendarEvent.StartTime,'yyyy-MM-dd HH:mm:ss')
    let endDateTime = format(calendarEvent.EndTime,'yyyy-MM-dd HH:mm:ss')

    // if recurring event then the end_date_time = the RecurrenceRule
    if (parsedRule.until !== null) {
      endDateTime = [parsedRule.until, endDateTime.split(' ')[1]].join(' ')
    }

    return {
      owner: calendarEvent.InspectorId,
      name: calendarEvent.Subject,
      start_date_time: startDateTime,
      end_date_time: endDateTime,
      type: this.getEventType(calendarEvent.EventType),
      recurring_type: parsedRule.frequency,
      description: calendarEvent.Description,
    }
  }

  getEventType(type) {
    const eventTypes = {
      [AVAILABLE]: 'available',
      [NOT_AVAILABLE]: 'not_available',
      [SCHEDULING_NOTE]: 'scheduling_note',
    }

    return eventTypes[type]
  }

  parseRecurrenceRule(recurrenceRule) {
    if (recurrenceRule === undefined || recurrenceRule === null) {
      return {
        frequency: null,
        until: null,
      }
    }

    const match = recurrenceRule.match(/FREQ=(.*?);.*UNTIL=(.*)/)
    const until = format(parseISO(match[2]), 'yyyy-MM-dd')

    return {
      frequency: match[1].toLowerCase(),
      until: until,
    }
  }

  handleEmptySubject(args) {
    if (['Add title', '(No Title)'].includes(args.element.querySelector('.e-subject').innerText)) {
      const subject = args.element.querySelector('.e-subject')
      subject.parentElement.removeChild(subject)
    }
  }
}